import React from 'react';
import { Button, Modal } from '@economic/gaudi';
import { Row, Column } from '../../../../shared/components/Grid/Grid';
import { Wizard } from './Wizard/Wizard';
import CoverImageDanish from './images/userpanel_cover_da.png';
import CoverImageEnglish from './images/userpanel_cover_en.png';
import { t, tBB } from '../../../../shared/components/l10n/l10n';
import { hasEnLangCode } from './util';
import ExternalLink from '../../../../../app/shared/components/ExternalLink';
import { useCurrentLocale } from '@economic/react-app';

interface Props {
    refresh: () => void;
}

export const Register = ({ refresh }: Props) => {
    const locale = useCurrentLocale();
    const image = hasEnLangCode(locale.languageCode) ? CoverImageEnglish : CoverImageDanish;

    return (
        <div className="view__user_panel__unregistered">
            <Row>
                <Column>
                    <div className="view__user_panel__container_left">
                        <div>
                            <div className="view__user_panel__info_card__border">
                                <div className="view__user_panel__content view__user_panel__image">
                                    <img src={image} />
                                </div>
                                <div className="view__user_panel__content view__user_panel__welcome">
                                    <h3>{t`USER_PANEL_JOIN_TITLE`}</h3>
                                    <p>{t`USER_PANEL_JOIN_INFORMATION_1`}</p>

                                    <p>{t`USER_PANEL_JOIN_INFORMATION_2`}</p>

                                    <Button
                                        appearance="primary"
                                        className="mt-6"
                                        modal={modalProps => (
                                            <Modal {...modalProps} style={{ width: '700px' }}>
                                                {({ hide }) => <Wizard onCancel={hide} refresh={refresh} />}
                                            </Modal>
                                        )}>
                                        {t`USER_PANEL_JOIN_BUTTON`}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Column>
                <Column>
                    <div className="view__user_panel__container_right">
                        <div>
                            <div className="view__user_panel__info_card__border">
                                <div className="view__user_panel__content view__user_panel__schedule">
                                    <h2 className="leading-tight text-lg">{t`USER_PANEL_PARTICIPATE_TITLE`}</h2>
                                    <p>{t`USER_PANEL_PARTICIPATE_INFORMATION_1`}</p>
                                    <p>{t`USER_PANEL_PARTICIPATE_INFORMATION_2`}</p>
                                </div>
                            </div>
                            <div className="view__user_panel__info_card__border">
                                <div className="view__user_panel__content view__user_panel__charity">
                                    <h2 className="leading-tight text-lg">{t`USER_PANEL_CHARITY_TITLE`}</h2>
                                    <p>
                                        {tBB('USER_PANEL_CHARITY_INFORMATION_1', {
                                            __LINK: content => (
                                                <ExternalLink href="https://www.hackyourfuture.dk/">{content}</ExternalLink>
                                            ),
                                        })}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Column>
            </Row>
        </div>
    );
};
